<template>
  <div id="app">
    <Menu/>
    <Banner/>
    <Welcome/>
    <SideInfo/>
    <Courses/>
    <Info/>
    <ThreeSlide/>
    <SideLeft/>
    <Contact/>
  </div>
</template>

<script>
import Menu from './components/Menu.vue';
import Banner from './components/Banner.vue';
import Welcome from './components/Welcome.vue';
import SideInfo from './components/SideInfo.vue';
import SideLeft from './components/SideLeft.vue';
import Courses from './components/Courses.vue';
import Info from './components/Info.vue';
import ThreeSlide from './components/ThreeSlide.vue';
import Contact from './components/Contact.vue';
export default {
  name: 'app',
  components: {
    Menu,
    Banner,
    Welcome,
    SideInfo,
    Courses,
    Info,
    SideLeft,
    ThreeSlide,
    Contact
  }
}
</script>

<style>
#app {
  font-family: "Poppins", serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
}

::placeholder{
    color: #5D867C !important;
}

.modal-header,
.modal-footer{
    display: none !important;
}

.modal-content{
  padding: 5%;
  background: #EEBBAE !important;
  border-radius: 20px !important;
  max-width: 85% !important;
}
.modal-body{
  background: #fff;
  border-radius: 20px;
  padding: 7% 5% !important;
  text-align: center;
}

.modal-body p{
  font-size: 20px;
  max-width: 535px;
  margin: auto;
  margin-bottom: 30px;
}

.modal-body .form-control{
    border: 1px solid #EEBBAE;
    max-width: 458.67px;
    border-radius: 15px !important;
    font-size: 20px;
    color: #EEBBAE;
    padding-top: 15px;
    padding-bottom: 15px;
    height: auto;
}

.modal-input::placeholder{
    color: #EEBBAE !important;
}
.modal-body .btn{
  margin: auto;
  background: #D37353 !important;
  width: 100%;
  font-size: 20px;
  max-width: 435px;
}

.navbar-light .navbar-toggler{
    border: none !important;
}

.navbar-light .navbar-toggler-icon {
    background-image: url(data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e) !important;
}

.slick-prev, .slick-next{
  background: red !important;
}
</style>
